const isLoggedIn = Boolean(sessionStorage.getItem("isLoggedIn"))
	? Boolean(sessionStorage.getItem("isLoggedIn"))
	: false;

const state = {
	isLoggedIn: isLoggedIn,
	isSplitView: false,
};

const mutations = {
	setIsLoggedIn(state) {
		sessionStorage.setItem("isLoggedIn", true);
		state.isLoggedIn = true;
	},

	setIsLoggedOut(state) {
		sessionStorage.removeItem("isLoggedIn", false);
		state.isLoggedIn = Boolean(false);
	},

	SET_SPLIT_VIEW(state, payload) {
    state.isSplitView = payload;
  },
};

const actions = {
	setSplitView(context, payload) {
		context.commit("SET_SPLIT_VIEW", payload);
	},
};

const getters = {
	getSplitView(state) {
    return state.isSplitView;
  },
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
